/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef} from 'react'
import {SketchPicker} from 'react-color'
import PropTypes from 'prop-types'
import './index.css'

const ThemeColors = ({color, setFieldValue}) => {
  const [selectedColor, setSelectedColor] = useState(color || '')
  const [showPicker, setShowPicker] = useState(false)
  const [openAbove, setOpenAbove] = useState(false)
  const buttonRef = useRef(null)

  const handleChange = (newColor) => {
    const hex = newColor.hex
    setFieldValue('pod_pref_color', hex)
    setSelectedColor(hex)
  }

  const togglePicker = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect()
      const spaceBelow = window.innerHeight - rect.bottom
      const spaceAbove = rect.top

      // Open above if less than 300px below and more space above
      setOpenAbove(spaceBelow < 300 && spaceAbove > spaceBelow)
    }
    setShowPicker((prev) => !prev)
  }

  return (
    <div className='w-100 card card-xl-stretch position-relative'>
      <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
        Brand Color
        <i
          className='fas fa-info-circle ms-2 fs-7'
          data-bs-toggle='tooltip'
          title='Choose the color scheme or palette that best represents your organization.'
        />
      </label>

      <div className='d-flex align-items-center'>
        <button
          ref={buttonRef}
          type='button'
          className='btn btn-unstyled'
          style={{
            backgroundColor: selectedColor,
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            cursor: 'pointer',
          }}
          onClick={togglePicker}
        />

        <div className='ms-3'>
          <p className='text-dark fw-normal mb-1 fs-6'>Selected Color</p>
          <div className='d-flex align-items-center'>
            <span className='text-muted fs-7'>{selectedColor}</span>
            <button
              type='button'
              className='btn btn-unstyled badge bg-light-primary ms-2'
              style={{borderRadius: '50px', padding: '2px 10px', fontSize: '0.8rem'}}
              onClick={togglePicker}
            >
              Change
            </button>
          </div>
        </div>
      </div>

      {showPicker && (
        <>
          {/* Overlay to close picker on outside click */}
          <div
            className='position-fixed'
            style={{top: 0, left: 0, right: 0, bottom: 0, zIndex: 998}}
            onClick={() => setShowPicker(false)}
          />
          <div
            style={{
              position: 'absolute',
              // top: '-80px',
              // right: '250px',
              zIndex: 999,
            }}
            className='custom-position'
          >
            <SketchPicker color={selectedColor} onChange={handleChange} />
          </div>
        </>
      )}
    </div>
  )
}

ThemeColors.propTypes = {
  color: PropTypes.string,
  setFieldValue: PropTypes.func,
}

export default ThemeColors
